/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*****************************************!*\
  !*** ./src/assets/js/bundle_packpdp.js ***!
  \*****************************************/
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
window._ambrosiaProductCache = window._ambrosiaProductCache || new Map();
window._ambrosiaGalleryHtmlCache = window._ambrosiaGalleryHtmlCache || new Map();
function getSkioSellingPlanGroups(product) {
  if (!product?.selling_plan_groups?.length) return [];
  return product.selling_plan_groups.filter(group => group.app_id === 'SKIO');
}
function findSkioSellingPlanById(product, sellingPlanId) {
  const id = parseInt(sellingPlanId, 10);
  for (const group of getSkioSellingPlanGroups(product)) {
    const plan = (group.selling_plans || []).find(p => p.id === id);
    if (plan) return plan;
  }
  return null;
}
function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}
function updateSellingPlanForPackIndex(scope, packIndex) {
  const root = scope?.closest?.('product-info') || (scope?.tagName === 'PRODUCT-INFO' ? scope : null) || scope || document;
  const sellingPlanSelect = root.querySelector('selling-plan-form select[name="selling_plan"]') || root.querySelector('pack-product-form select[name="selling_plan"]');
  if (!sellingPlanSelect || !sellingPlanSelect.options.length) return;
  const targetIndex = clamp(packIndex, 0, sellingPlanSelect.options.length - 1);
  if (sellingPlanSelect.selectedIndex === targetIndex) return;
  sellingPlanSelect.selectedIndex = targetIndex;
  sellingPlanSelect.dispatchEvent(new Event('change', {
    bubbles: true
  }));
}
if (!customElements.get('pack-product-form')) {
  customElements.define('pack-product-form', class PackProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      const hasPackRadios = !!this.querySelector('[name="pack"]');
      const hasMultiPackSelector = !!this.querySelector('.pack-selector[data-multi-pack="true"]');
      this.usesPackUi = hasPackRadios || hasMultiPackSelector;
      if (!this.usesPackUi) {
        return;
      }
      const singlePack = this.querySelector('[name="pack"][value="single"]') || this.querySelector('[name="pack"][value="Single"]');
      if (singlePack) {
        singlePack.checked = true;
        this.activePack = singlePack.value;
      } else {
        const checkedPack = this.querySelector('[name="pack"]:checked');
        this.activePack = checkedPack ? checkedPack.value : null;
      }
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
      if (this.submitButton) {
        this.submitButtonText = this.submitButton.querySelector('span');
      }
      this.error = false;
      this.lastModifiedFlavorSelect = null;
      if (this.form) {
        this.form.addEventListener('submit', this.onSubmit.bind(this), {
          capture: true
        });
      }
      this.hideExistingFlavorSelectors();
      this.observeButtonText();
      this.init();
    }
    init() {
      if (!this.activePack) return;
      this.bindPackSwitch();
      this.bindPurchaseOptions();
      this.loadPackProduct();
      requestAnimationFrame(() => this.updateSubmitButtonLabel());
    }
    hideExistingFlavorSelectors() {
      this.querySelectorAll('[class*="flavor-selector-"]').forEach(selector => {
        selector.style.display = 'none';
      });
    }
    showFlavorSelectorsForPack(packKey) {
      this.querySelectorAll('[class*="flavor-selector-"]').forEach(selector => {
        selector.style.display = 'none';
      });
      const packInfo = this.getPackInfo(packKey);
      if (!packInfo) return;
      for (let i = 1; i <= packInfo.quantity; i++) {
        const selector = this.querySelector(`.flavor-selector-${packKey}[data-flavor-index="${i}"]`);
        if (selector) {
          selector.style.display = '';
        }
      }
    }
    bindPackSwitch() {
      this.updatePackSelection();
      this.showFlavorSelectorsForPack(this.activePack);
      const packSelectDropdown = this.querySelector('#pack-select-dropdown');
      const packSelectTrigger = this.querySelector('#pack-select-dropdown-trigger');
      const packSelectOptions = this.querySelector('#pack-select-dropdown-options');
      const packSelectWrapper = this.querySelector('.pack-select-dropdown__wrapper');
      if (packSelectTrigger && packSelectOptions && packSelectWrapper) {
        const updateDropdownDisplay = packKey => {
          const selectedOption = packSelectOptions.querySelector(`[data-pack-key="${packKey}"]`);
          if (selectedOption) {
            const selectedDisplay = packSelectTrigger.querySelector('.pack-select-dropdown__selected');
            const optionImage = selectedOption.querySelector('.pack-select-dropdown__option-image');
            const optionLabel = selectedOption.querySelector('.pack-select-dropdown__option-label');
            const optionSubtitle = selectedOption.querySelector('.pack-select-dropdown__option-subtitle');
            const optionBadge = selectedOption.querySelector('.pack-select-dropdown__option-badge');
            const displayImage = selectedDisplay.querySelector('.pack-select-dropdown__image');
            const displayLabel = selectedDisplay.querySelector('.pack-select-dropdown__label');
            const displaySubtitle = selectedDisplay.querySelector('.pack-select-dropdown__subtitle');
            const displayBadge = selectedDisplay.querySelector('.pack-select-dropdown__badge');
            if (displayLabel && optionLabel) {
              displayLabel.textContent = optionLabel.textContent;
            }
            if (displaySubtitle && optionSubtitle) {
              displaySubtitle.textContent = optionSubtitle.textContent;
            }
            if (optionImage) {
              if (displayImage) {
                displayImage.src = optionImage.src;
                displayImage.alt = optionImage.alt;
              } else {
                const newImage = document.createElement('img');
                newImage.src = optionImage.src;
                newImage.alt = optionImage.alt;
                newImage.className = 'pack-select-dropdown__image';
                newImage.loading = 'lazy';
                if (displayLabel && displayLabel.parentElement) {
                  selectedDisplay.insertBefore(newImage, selectedDisplay.firstChild);
                }
              }
            } else if (displayImage) {
              displayImage.remove();
            }
            if (displayBadge && optionBadge) {
              displayBadge.textContent = optionBadge.textContent;
              displayBadge.style.display = 'inline-block';
            } else if (displayBadge && !optionBadge) {
              displayBadge.style.display = 'none';
            }
            if (packSelectDropdown) {
              packSelectDropdown.value = packKey;
            }
            packSelectWrapper.setAttribute('data-selected-pack', packKey);
          }
        };
        updateDropdownDisplay(this.activePack);
        packSelectTrigger.addEventListener('click', e => {
          e.stopPropagation();
          const isOpen = packSelectWrapper.getAttribute('data-open') === 'true';
          packSelectWrapper.setAttribute('data-open', !isOpen);
          packSelectTrigger.setAttribute('aria-expanded', !isOpen);
        });
        const handleOptionClick = e => {
          const option = e.target.closest('.pack-select-dropdown__option');
          if (!option) return;
          e.stopPropagation();
          e.preventDefault();
          const packKey = option.getAttribute('data-pack-key');
          if (!packKey) return;
          const correspondingRadio = this.querySelector(`[name="pack"][value="${packKey}"]`);
          if (correspondingRadio) {
            correspondingRadio.checked = true;
            correspondingRadio.dispatchEvent(new Event('change', {
              bubbles: true
            }));
          }
          packSelectWrapper.setAttribute('data-open', 'false');
          packSelectTrigger.setAttribute('aria-expanded', 'false');
        };
        packSelectOptions.addEventListener('click', handleOptionClick);
        packSelectOptions.addEventListener('mousedown', e => {
          const option = e.target.closest('.pack-select-dropdown__option');
          if (option) {
            e.stopPropagation();
          }
        });
        const handleOutsideClick = e => {
          if (!packSelectWrapper.contains(e.target)) {
            packSelectWrapper.setAttribute('data-open', 'false');
            packSelectTrigger.setAttribute('aria-expanded', 'false');
          }
        };
        document.addEventListener('click', handleOutsideClick, true);
        this.updateDropdownDisplay = updateDropdownDisplay;
      }
      this.querySelectorAll('[name="pack"]').forEach(radio => {
        radio.addEventListener('click', e => {
          if (radio.checked && radio.value !== 'single' && radio.value !== 'Single' && this.activePack === radio.value) {
            e.preventDefault();
            e.stopPropagation();
            const singleRadio = this.querySelector('[name="pack"][value="single"]') || this.querySelector('[name="pack"][value="Single"]');
            if (singleRadio) {
              singleRadio.checked = true;
              this.activePack = singleRadio.value;
              this.updatePackSelection();
              this.showFlavorSelectorsForPack(this.activePack);
              this.lastModifiedFlavorSelect = null;
              this.loadPackProduct();
              if (this.updateDropdownDisplay) {
                this.updateDropdownDisplay(this.activePack);
              }
            }
          }
        });
        radio.addEventListener('change', () => {
          this.activePack = radio.value;
          this.updatePackSelection();
          this.showFlavorSelectorsForPack(this.activePack);
          this.lastModifiedFlavorSelect = null;
          this.loadPackProduct();
          requestAnimationFrame(() => this.updateSubmitButtonLabel());
          if (this.updateDropdownDisplay) {
            this.updateDropdownDisplay(this.activePack);
          }
        });
      });
    }
    updatePackSelection() {
      this.querySelectorAll('.pack-option').forEach(option => {
        option.classList.remove('selected');
      });
      const activeRadio = this.querySelector(`[name="pack"][value="${this.activePack}"]`);
      if (activeRadio) {
        const packOption = activeRadio.closest('.pack-option');
        if (packOption) {
          packOption.classList.add('selected');
        }
      }
    }
    renderFlavorsFromProduct(product, quantity) {
      this.showFlavorSelectorsForPack(this.activePack);
    }
    getFlavorProperties() {
      const props = {};
      this.querySelectorAll('[class*="flavor-selector-"]').forEach(selector => {
        if (selector.style.display === 'none') return;
        const select = selector.querySelector('select');
        if (select) {
          const packKey = selector.className.match(/flavor-selector-([^\s]+)/)?.[1];
          if (packKey) {
            props[`Flavor ${packKey}`] = select.value;
          }
        }
      });
      return props;
    }
    getActivePackIndex() {
      const radios = Array.from(this.querySelectorAll('[name="pack"]'));
      const checked = this.querySelector('[name="pack"]:checked');
      return Math.max(0, radios.indexOf(checked));
    }
    selectSellingPlanForActivePack() {
      updateSellingPlanForPackIndex(this, this.getActivePackIndex());
    }
    getPackInfo(packKey) {
      const packInput = this.querySelector(`input[name="pack"][value="${packKey}"]`);
      if (!packInput) return null;
      const defaultVariantIdRaw = packInput.dataset.defaultVariantId;
      const defaultVariantId = defaultVariantIdRaw ? parseInt(defaultVariantIdRaw, 10) : null;
      return {
        key: packKey,
        quantity: parseInt(packInput.dataset.packQuantity || '1', 10),
        productHandle: packInput.dataset.productHandle,
        productId: parseInt(packInput.dataset.productId || '0', 10),
        defaultVariantId: Number.isFinite(defaultVariantId) ? defaultVariantId : null
      };
    }
    getVariantIdForFlavor(product, flavorValue) {
      if (!product || !product.variants) return null;
      const flavorOption = product.options.find(opt => opt.name.toLowerCase() === 'flavor' || opt.name.toLowerCase() === 'flavour');
      if (!flavorOption) return product.variants[0]?.id || null;
      const flavorIndex = flavorOption.position - 1;
      const variant = product.variants.find(v => {
        return v.options[flavorIndex] === flavorValue;
      });
      return variant?.id || product.variants[0]?.id || null;
    }
    async loadPackProduct() {
      const packInfo = this.getPackInfo(this.activePack);
      if (!packInfo?.productHandle) return;
      const requestId = Date.now();
      this._lastRequestId = requestId;
      try {
        const cache = window._ambrosiaProductCache;
        if (!cache.has(packInfo.productHandle)) {
          cache.set(packInfo.productHandle, fetch(`/products/${packInfo.productHandle}.js`).then(r => r.json()));
        }
        const product = await cache.get(packInfo.productHandle);
        if (this._lastRequestId !== requestId) return;
        this.currentProduct = product;
        this.updateFlavorSelectors(product);
        this.updateSellingPlans(product);
        this.selectSellingPlanForActivePack();
        this.updatePrice();
        this.updateSubmitButtonLabel();
        this.updateGalleryForPackProduct();
      } catch (error) {
        console.error('Error loading pack product:', error);
      }
    }
    updateFlavorSelectors(product) {
      this.showFlavorSelectorsForPack(this.activePack);
      this.bindFlavorSelectorChanges();
    }
    bindFlavorSelectorChanges() {
      const flavorSelects = this.querySelectorAll('select[data-pack-key][data-flavor-index]');
      flavorSelects.forEach(select => {
        if (select.dataset.galleryListenerAdded === 'true') {
          return;
        }
        select.dataset.galleryListenerAdded = 'true';
        select.addEventListener('change', e => {
          this.lastModifiedFlavorSelect = e.target;
          this.updatePrice();
          console.log('[Bundle Pack PDP] flavor selector changed:', e.target.value);
          clearTimeout(this._galleryDebounceTimer);
          this._galleryDebounceTimer = setTimeout(() => {
            this.updateGalleryFromFlavorSelect(e.target);
          }, 150);
        });
      });
    }
    updateGalleryForPackProduct() {
      const productInfo = this.closest('product-info');
      if (!productInfo || !this.currentProduct) return;
      if (this.querySelector('.pack-selector[data-multi-pack="true"]')) return;
    }
    updateGalleryFromFlavorSelect(selectElement) {
      const productInfo = this.closest('product-info');
      if (!productInfo || !this.currentProduct || !selectElement) return;
      const selectedOption = selectElement.options[selectElement.selectedIndex];
      if (!selectedOption) return;
      const variantId = selectedOption?.dataset?.variantId;
      if (!variantId) return;
      const variant = this.currentProduct.variants?.find(v => v.id.toString() === variantId);
      if (!variant) return;
      const productUrl = this.currentProduct.handle ? `/products/${this.currentProduct.handle}` : productInfo.dataset.url || '';
      if (!productUrl) return;
      const baseUrl = productUrl.split('?')[0];
      const fetchParams = new URLSearchParams();
      fetchParams.set('variant', variantId);
      if (productInfo.dataset.section) {
        fetchParams.set('section_id', productInfo.dataset.section);
      }
      const variantUrl = `${baseUrl}?${fetchParams.toString()}`;
      console.log('[Bundle Pack PDP] fetching product HTML for variant:', variantUrl);
      const galleryCache = window._ambrosiaGalleryHtmlCache;
      const cachedDoc = galleryCache.get(variantUrl);
      const htmlPromise = cachedDoc ? Promise.resolve(cachedDoc) : fetch(variantUrl, {
        headers: {
          Accept: 'text/html'
        }
      }).then(response => response.text()).then(htmlText => {
        const doc = new DOMParser().parseFromString(htmlText, 'text/html');
        galleryCache.set(variantUrl, doc);
        return doc;
      });
      htmlPromise.then(html => {
        const mediaGallery = productInfo.querySelector('media-gallery');
        const allowGalleryUpdate = mediaGallery && typeof productInfo.hasGalleryAltConvention === 'function' && productInfo.hasGalleryAltConvention(mediaGallery);
        console.log('[Bundle Pack PDP] allowGalleryUpdate:', allowGalleryUpdate, '| variant:', variant.title, '| options:', variant.options, '| featured_media:', variant.featured_media?.id);
        if (allowGalleryUpdate && productInfo.updateMedia) {
          productInfo.updateMedia(html, variant.featured_media?.id, variant);
        } else if (!allowGalleryUpdate) {
          console.log('[Bundle Pack PDP] allowGalleryUpdate false — forcing gallery reinit from fetched HTML');
          if (productInfo.updateMedia) {
            productInfo.updateMedia(html, variant.featured_media?.id, variant);
          }
        }
        if (typeof productInfo.updateVariantSpecialImagesFromVariant === 'function') {
          productInfo.updateVariantSpecialImagesFromVariant(variant);
        }
        if (typeof productInfo.updateVariantSpecificContentFromDoc === 'function') {
          productInfo.updateVariantSpecificContentFromDoc(html);
        } else {
          const accordions = productInfo.querySelectorAll('[data-variant-specific-accordion]');
          accordions.forEach(accordion => {
            const source = html.getElementById(accordion.id) || html.querySelector(`[id="${accordion.id}"]`);
            if (source) accordion.innerHTML = source.innerHTML;
          });
        }
      }).catch(error => {
        console.error('Error fetching product HTML:', error);
      });
    }
    updateSellingPlans(product) {
      const sellingPlanSelect = this.querySelector('select[name="selling_plan"]');
      const subscriptionSection = this.querySelector('.purchase-options');
      const qtyUnitVariant = this.getQuantityPackBaseVariant(product);
      const representativeVariant = qtyUnitVariant ?? product?.variants?.[0];
      const validPlanIds = new Set((representativeVariant?.selling_plan_allocations || []).map(a => String(a.selling_plan_id)));
      const hasValidPlans = validPlanIds.size > 0 && sellingPlanSelect;
      if (!hasValidPlans) {
        if (subscriptionSection) subscriptionSection.style.display = 'none';
        const onetimeRadio = this.querySelector('[name="purchase_option"][value="onetime"]');
        if (onetimeRadio && !onetimeRadio.checked) {
          onetimeRadio.checked = true;
          onetimeRadio.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        }
        this.updatePrice();
        return;
      }
      if (subscriptionSection) subscriptionSection.style.display = '';
      const currentValue = sellingPlanSelect.value;
      sellingPlanSelect.innerHTML = '';
      let filtered_selling_plan_groups = product.selling_plan_groups.filter(group => group.app_id === "SKIO");
      if (filtered_selling_plan_groups && filtered_selling_plan_groups.length > 0) {
        filtered_selling_plan_groups.forEach(group => {
          if (group.selling_plans && group.selling_plans.length > 0) {
            group.selling_plans.forEach(plan => {
              const planName = (plan.name || plan.description || '').trim();
              if (!planName.startsWith('Delivery ')) return;
              if (!validPlanIds.has(String(plan.id))) return;
              const option = document.createElement('option');
              option.value = plan.id;
              option.textContent = planName || `Plan ${plan.id}`;
              if (plan.id.toString() === currentValue) {
                option.selected = true;
              }
              sellingPlanSelect.appendChild(option);
            });
          }
        });
      }
      if (sellingPlanSelect.options.length > 0 && !sellingPlanSelect.value) {
        sellingPlanSelect.selectedIndex = 0;
      }
      this.updatePrice();
    }
    bindPurchaseOptions() {
      this.updatePurchaseOptionSelection();
      this.updateSubmitButtonLabel();
      this.querySelectorAll('[name="purchase_option"]').forEach(radio => {
        radio.addEventListener('change', () => {
          this.updatePurchaseOptionSelection();
          this.updatePrice();
          this.updateSubmitButtonLabel();
        });
      });
      const sellingPlanSelect = this.querySelector('select[name="selling_plan"]');
      if (sellingPlanSelect) {
        sellingPlanSelect.addEventListener('change', () => {
          this.updatePrice();
          this.updateSubmitButtonLabel();
        });
      }
    }
    updatePurchaseOptionSelection() {
      this.querySelectorAll('.purchase-option').forEach(option => {
        option.classList.remove('selected');
      });
      const activeRadio = this.querySelector('[name="purchase_option"]:checked');
      if (activeRadio) {
        const purchaseOption = activeRadio.closest('.purchase-option');
        if (purchaseOption) {
          purchaseOption.classList.add('selected');
        }
      }
    }
    updateSubmitButtonLabel() {
      if (!this.submitButton || !this.submitButtonText) return;
      if (this.submitButton.classList.contains('loading') || this.submitButton.hasAttribute('aria-disabled')) {
        return;
      }
      const subscriptionSelected = this.querySelector('[name="purchase_option"][value="subscription"]')?.checked;
      if (subscriptionSelected) {
        this.submitButtonText.textContent = 'Add to cart';
      } else {
        if (window.variantStrings && window.variantStrings.addToCart) {
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        } else {
          this.submitButtonText.textContent = 'Add to cart';
        }
      }
    }
    getSellingPlanId() {
      const isSub = this.querySelector('[name="purchase_option"][value="subscription"]')?.checked;
      if (!isSub) return null;
      const sellingPlanSelect = this.querySelector('select[name="selling_plan"]');
      if (sellingPlanSelect && sellingPlanSelect.value) {
        return parseInt(sellingPlanSelect.value, 10);
      }
      return null;
    }
    getPackSelectorRoot() {
      return this.querySelector('.pack-selector[data-multi-pack="true"]');
    }
    getQuantityPackBaseVariant(product) {
      const root = this.getPackSelectorRoot();
      if (!root || root.dataset.packUseQuantityPricing !== 'true') return null;
      const vid = root.dataset.packPricingVariantId;
      if (!vid || !product?.variants?.length) return null;
      return product.variants.find(v => String(v.id) === String(vid)) || null;
    }
    resolveVariantFromSlot(slotEl) {
      if (!slotEl || !this.currentProduct?.variants?.length) return null;
      const selects = slotEl.querySelectorAll('select[data-pack-key][data-flavor-index]');
      const values = Array.from(selects).map(s => s.value);
      if (values.length) {
        const exact = this.currentProduct.variants.find(v => Array.isArray(v.options) && v.options.every((opt, idx) => opt === values[idx]));
        if (exact) return exact;
      }
      const fallbackSelect = slotEl.querySelector('select');
      const vid = fallbackSelect?.options?.[fallbackSelect.selectedIndex]?.dataset?.variantId;
      if (vid) {
        return this.currentProduct.variants.find(v => String(v.id) === String(vid)) || null;
      }
      return null;
    }
    getInitialSelectedVariant() {
      const script = this.querySelector('script[type="application/json"][data-selected-variant]');
      if (!script) return null;
      try {
        const parsed = JSON.parse(script.textContent || 'null');
        if (!parsed || typeof parsed !== 'object') return null;
        if (parsed.id && this.currentProduct?.variants?.length) {
          const match = this.currentProduct.variants.find(v => v.id === parsed.id);
          if (match) return match;
        }
        return parsed;
      } catch (_) {
        return null;
      }
    }
    getOneTimePackTotalCents() {
      if (!this.currentProduct || !this.activePack) return 0;
      const packInfo = this.getPackInfo(this.activePack);
      const quantity = packInfo?.quantity || 1;
      const qtyUnitVariant = this.getQuantityPackBaseVariant(this.currentProduct);
      if (qtyUnitVariant) {
        return qtyUnitVariant.price * quantity;
      }
      const packSelectors = this.querySelectorAll(`.flavor-selector-${this.activePack}`);
      let sum = 0;
      let any = false;
      packSelectors.forEach(selector => {
        if (selector.style.display === 'none') return;
        const variant = this.resolveVariantFromSlot(selector);
        if (variant) {
          sum += variant.price;
          any = true;
        }
      });
      if (any) return sum;
      const initialVariant = this.getInitialSelectedVariant();
      const unit = initialVariant?.price ?? this.currentProduct.variants?.[0]?.price ?? this.currentProduct.price ?? 0;
      return unit * quantity;
    }
    syncMainProductPriceFromPack(totalCents) {
      const productInfo = this.closest('product-info');
      if (!productInfo || productInfo.dataset.mainSellingPlans === 'true') return;
      const sectionId = productInfo.dataset.section;
      if (!sectionId) return;
      const formatted = typeof Shopify !== 'undefined' && Shopify.formatMoney ? Shopify.formatMoney(totalCents) : `$${(totalCents / 100).toFixed(2)}`;
      const fullId = `price-${sectionId}`;
      const esc = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(fullId) : fullId;
      productInfo.querySelectorAll(`[id="${esc}"]`).forEach(holder => {
        const saleEl = holder.querySelector('.price-item--sale.price-item--last');
        const regularEl = holder.querySelector('.price__regular .price-item--regular');
        const target = saleEl || regularEl;
        if (target) target.textContent = formatted;
      });
    }
    updatePrice() {
      if (!this.currentProduct || !this.activePack) {
        return;
      }
      const packInfo = this.getPackInfo(this.activePack);
      const quantity = packInfo?.quantity || 1;
      const otPrice = this.getOneTimePackTotalCents();
      let sbsPrice = otPrice;
      const sellingPlanSelect = this.querySelector('select[name="selling_plan"]');
      if (sellingPlanSelect && sellingPlanSelect.value) {
        const plan = findSkioSellingPlanById(this.currentProduct, sellingPlanSelect.value);
        if (plan?.price_adjustments?.length > 0) {
          const adjustment = plan.price_adjustments[0];
          if (adjustment.value_type === 'percentage') {
            sbsPrice = otPrice * (1 - adjustment.value / 100);
          } else if (adjustment.value_type === 'fixed_amount') {
            sbsPrice = otPrice - adjustment.value * quantity;
          }
        }
      }
      const otPriceElement = this.querySelector('[data-option="onetime"] [data-pack-price]');
      if (otPriceElement) {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          otPriceElement.textContent = Shopify.formatMoney(otPrice);
        } else {
          otPriceElement.textContent = `$${(otPrice / 100).toFixed(2)}`;
        }
      }
      const sbsPriceElement = this.querySelector('[data-option="subscription"] [data-pack-price]');
      if (sbsPriceElement) {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          sbsPriceElement.textContent = Shopify.formatMoney(sbsPrice);
        } else {
          sbsPriceElement.textContent = `$${(sbsPrice / 100).toFixed(2)}`;
        }
      }
      const originalPriceElement = this.querySelector('[data-option="subscription"] .original-price');
      const discountBadge = this.querySelector('[data-option="subscription"] .discount-badge');
      if (originalPriceElement && discountBadge) {
        originalPriceElement.style.display = 'inline';
        discountBadge.style.display = 'inline';
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          originalPriceElement.textContent = Shopify.formatMoney(otPrice);
        } else {
          originalPriceElement.textContent = `$${(otPrice / 100).toFixed(2)}`;
        }
        const discountPercent = Math.round((otPrice - sbsPrice) / otPrice * 100);
        if (discountPercent > 0) {
          discountBadge.textContent = `Save ${discountPercent}%`;
        } else {
          discountBadge.style.display = 'none';
        }
      }
      this.syncMainProductPriceFromPack(otPrice);
    }
    handleErrorMessage(message = '') {
      const errorMessage = this.querySelector('.product-form__error-message');
      if (!errorMessage) return;
      errorMessage.textContent = message;
      errorMessage.parentElement.hidden = !message;
    }
    observeButtonText() {
      if (!this.submitButton || !this.submitButtonText) return;
      let isUpdating = false;
      this.buttonObserver = new MutationObserver(() => {
        if (isUpdating) return;
        const subscriptionSelected = this.querySelector('[name="purchase_option"][value="subscription"]')?.checked;
        if (subscriptionSelected && this.submitButtonText.textContent !== 'Subscribe' && !this.submitButton.classList.contains('loading')) {
          isUpdating = true;
          requestAnimationFrame(() => {
            this.submitButtonText.textContent = 'Add to cart';
            isUpdating = false;
          });
        }
      });
      this.buttonObserver.observe(this.submitButtonText, {
        characterData: true,
        childList: true
      });
    }
    onSubmit(evt) {
      if (!this.usesPackUi || !this.activePack) return;
      evt.preventDefault();
      evt.stopImmediatePropagation();
      evt.stopPropagation();
      if (!this.submitButton) return;
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      const items = this.buildItemsPayload();
      if (!items || items.length === 0) {
        this.handleErrorMessage('Please select flavors for all items.');
        return;
      }
      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      const loadingSpinner = this.querySelector('.loading__spinner');
      if (loadingSpinner) loadingSpinner.classList.remove('hidden');
      const config = typeof fetchConfig !== 'undefined' ? fetchConfig('json') : {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        }
      };
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      const body = {
        items
      };
      if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
        body.sections = this.cart.getSectionsToRender().map(section => section.id);
        body.sections_url = window.location.pathname;
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = JSON.stringify(body);
      const startMarker = typeof CartPerformance !== 'undefined' ? CartPerformance.createStartingMarker('add:wait-for-subscribers') : null;
      requestAnimationFrame(() => fetch(`${routes.cart_add_url}`, config).then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
          throw new Error('Response is not JSON');
        }
        return response.json();
      }).then(response => {
        if (response.status) {
          if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'pack-product-form',
              errors: response.errors || response.description,
              message: response.message
            });
          }
          this.handleErrorMessage(response.description || response.message || 'Unable to add items to cart.');
          this.error = true;
          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (soldOutMessage) {
            this.submitButton.setAttribute('aria-disabled', true);
            if (this.submitButtonText) {
              this.submitButtonText.classList.add('hidden');
            }
            soldOutMessage.classList.remove('hidden');
          }
          return;
        }
        this.error = false;
        if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish !== 'undefined') {
          const cartUpdatePromise = publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'pack-product-form',
            cartData: response
          });
          if (startMarker && cartUpdatePromise && typeof cartUpdatePromise.then === 'function') {
            cartUpdatePromise.then(() => {
              if (typeof CartPerformance !== 'undefined') {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              }
            });
          }
        }
        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }
        const renderCart = () => {
          this.cart.renderContents(response);
        };
        if (typeof CartPerformance !== 'undefined') {
          CartPerformance.measure('add:paint-updated-sections', renderCart);
        } else {
          renderCart();
        }
      }).catch(err => {
        console.error('Error adding to cart:', err);
        this.handleErrorMessage('Unable to add items to cart. Please try again.');
        this.error = true;
        if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'pack-product-form',
            errors: err.message,
            message: 'Unable to add items to cart.'
          });
        }
      }).finally(() => {
        this.submitButton.classList.remove('loading');
        if (loadingSpinner) {
          loadingSpinner.classList.add('hidden');
        }
        if (this.cart && this.cart.classList.contains('is-empty')) {
          this.cart.classList.remove('is-empty');
        }
        if (!this.error) {
          this.submitButton.removeAttribute('aria-disabled');
        }
        if (typeof CartPerformance !== 'undefined') {
          CartPerformance.measureFromEvent('add:user-action', evt);
        }
      }));
    }
    buildItemsPayload() {
      if (!this.activePack) {
        return [];
      }
      const sellingPlan = this.getSellingPlanId();
      const packInfo = this.getPackInfo(this.activePack);
      if (!packInfo) return [];
      const packSelectors = this.querySelectorAll(`.flavor-selector-${this.activePack}`);
      const hasFlavorSelectors = packSelectors.length > 0;
      if (!hasFlavorSelectors) {
        const qtyUnitVariant = this.getQuantityPackBaseVariant(this.currentProduct);
        const variantId = qtyUnitVariant?.id ?? packInfo.defaultVariantId ?? this.currentProduct?.variants?.[0]?.id;
        if (!variantId) return [];
        return [_objectSpread({
          id: parseInt(variantId, 10),
          quantity: packInfo.quantity || 1
        }, sellingPlan ? {
          selling_plan: sellingPlan
        } : {})];
      }
      const items = [];
      packSelectors.forEach(selector => {
        if (selector.style.display === 'none') return;
        let variantId;
        for (const sel of selector.querySelectorAll('select')) {
          const vid = sel.options?.[sel.selectedIndex]?.dataset?.variantId;
          if (vid) {
            variantId = vid;
            break;
          }
        }
        if (variantId) {
          items.push(_objectSpread({
            id: parseInt(variantId, 10),
            quantity: 1
          }, sellingPlan ? {
            selling_plan: sellingPlan
          } : {}));
        }
      });
      return items;
    }
    disconnectedCallback() {
      if (this.buttonObserver) {
        this.buttonObserver.disconnect();
      }
    }
  });
}
if (!window.AmbrosiaMultiPack) {
  window.AmbrosiaMultiPack = function () {
    const PACK_GALLERY_DEBUG = false;
    function packGalleryLog(...args) {
      if (PACK_GALLERY_DEBUG) console.log('[Pack Gallery]', ...args);
    }
    function hasGalleryAltConvention(mediaGallery) {
      if (!mediaGallery) return false;
      const imgs = mediaGallery.querySelectorAll('img[alt]');
      for (const img of imgs) {
        const a = (img.getAttribute('alt') || '').toLowerCase();
        if (a.includes('gallery')) return true;
      }
      return false;
    }
    function buildPackGalleryFetchUrl(productUrl, productInfo) {
      if (!productUrl) return '';
      const variant = getCurrentVariant(productInfo);
      const variantId = variant?.id;
      const sectionId = productInfo?.dataset?.section;
      try {
        const u = new URL(productUrl, window.location.origin);
        if (variantId) u.searchParams.set('variant', String(variantId));
        if (sectionId) u.searchParams.set('section_id', sectionId);
        return u.pathname + u.search + (u.hash || '');
      } catch (e) {
        const base = productUrl.split('?')[0];
        const params = new URLSearchParams();
        if (variantId) params.set('variant', String(variantId));
        if (sectionId) params.set('section_id', sectionId);
        const q = params.toString();
        return q ? `${base}?${q}` : productUrl;
      }
    }
    function updateSellingPlanForPack(root, packIndex) {
      updateSellingPlanForPackIndex(root, packIndex);
    }
    function getPackKeyFromElement(element) {
      return element?.value || element?.getAttribute?.('data-pack-key') || '';
    }
    function slideMatchesPackAlt(alt, packKey) {
      const altLower = (alt || '').toLowerCase();
      const key = (packKey || '').toLowerCase();
      const isTagged = altLower.includes('gallery');
      if (!isTagged) return true;
      if (!key || key === 'single') {
        return altLower.includes('single ') && altLower.includes('gallery');
      }
      return altLower.includes(key) && altLower.includes('gallery');
    }
    function getPurchaseTypeKey(root) {
      const purchaseInput = root.querySelector('[name="purchase_option"]:checked');
      if (!purchaseInput) return '';
      const value = (purchaseInput.value || '').toLowerCase();
      if (value.includes('subscribe') || value.includes('subscription') || value.includes('selling_plan')) {
        return 'subscription';
      }
      if (value.includes('one-time') || value.includes('onetime') || value.includes('one_time') || value.includes('once')) {
        return 'one-time';
      }
      return '';
    }
    function slideMatchesCriteria(alt, criteria) {
      const altLower = (alt || '').toLowerCase();
      const packKey = criteria.packKey || '';
      const purchaseKey = criteria.purchaseKey || '';
      if (!slideMatchesPackAlt(altLower, packKey)) return false;
      if (purchaseKey === 'subscription' && altLower.includes('one-time')) return false;
      if (purchaseKey === 'one-time' && altLower.includes('subscription')) return false;
      return true;
    }
    function getFilteredSlides(cachedSlides, criteria) {
      if (!cachedSlides || !cachedSlides.length) return [];
      return cachedSlides.filter(slide => {
        const img = slide.querySelector('img[alt]');
        const alt = img ? img.getAttribute('alt') || '' : '';
        return slideMatchesCriteria(alt, criteria);
      });
    }
    function renderSlidesInnerHtml(wrapper, slidesToRender) {
      if (!wrapper) return;
      const safeSlides = slidesToRender || [];
      wrapper.innerHTML = safeSlides.map(slide => slide.outerHTML).join('');
    }
    function destroySwiper(swiperSlider) {
      if (!swiperSlider || !swiperSlider.swiperInstance) return;
      try {
        swiperSlider.swiperInstance.destroy(true, true);
      } catch (e) {}
      swiperSlider.swiperInstance = null;
    }
    function waitAndSlideToZero(swiperSlider) {
      const poll = () => {
        if (swiperSlider?.swiperInstance?.slides?.length > 0) {
          swiperSlider.swiperInstance.slideTo(0, 0);
        } else {
          setTimeout(poll, 50);
        }
      };
      setTimeout(poll, 100);
    }
    function getCurrentVariant(root) {
      if (!root) return null;
      if (typeof root.getSelectedVariant === 'function') {
        const v = root.getSelectedVariant(root);
        if (v) return v;
      }
      const selectedVariantJson = root.querySelector('[data-selected-variant]')?.textContent;
      if (!selectedVariantJson) return null;
      try {
        return JSON.parse(selectedVariantJson);
      } catch (e) {
        return null;
      }
    }
    async function updateMediaForPack(root, packIndex, packKey) {
      const mediaGallery = root.querySelector('media-gallery');
      if (!mediaGallery) {
        console.warn('[Pack Gallery] No media-gallery found');
        return;
      }
      const packInput = root.querySelector(`input[name="pack"][value="${packKey}"]`);
      packGalleryLog('packInput:', packInput, packInput?.dataset);
      const packProductUrl = packInput?.dataset?.productUrl;
      const productInfo = root.closest('product-info') || root;
      const pageUrl = productInfo?.dataset?.url;
      const productUrl = packProductUrl || pageUrl;
      packGalleryLog('packProductUrl:', packProductUrl, 'pageUrl:', pageUrl);
      if (!productUrl) {
        console.warn('[Pack Gallery] No productUrl');
        return;
      }
      const fetchUrl = buildPackGalleryFetchUrl(productUrl, productInfo);
      packGalleryLog('fetch URL:', fetchUrl);
      let html;
      try {
        const galleryCache = window._ambrosiaGalleryHtmlCache;
        if (galleryCache.has(fetchUrl)) {
          html = galleryCache.get(fetchUrl);
          packGalleryLog('gallery cache hit');
        } else {
          const response = await fetch(fetchUrl, {
            headers: {
              Accept: 'text/html'
            }
          });
          const htmlText = await response.text();
          html = new DOMParser().parseFromString(htmlText, 'text/html');
          galleryCache.set(fetchUrl, html);
          packGalleryLog('fetch success, cached');
        }
      } catch (e) {
        console.error('[Pack Gallery] fetch failed', e);
        return;
      }
      const fetchedViewerWrapper = html.querySelector('media-gallery swiper-slider[data-gallery-viewer="true"] .swiper-wrapper') || html.querySelector('media-gallery .swiper-wrapper');
      const fetchedThumbWrapper = html.querySelector('media-gallery swiper-slider[data-gallery-thumbnails="true"] .swiper-wrapper');
      packGalleryLog('fetchedViewerWrapper:', fetchedViewerWrapper);
      packGalleryLog('fetchedThumbWrapper:', fetchedThumbWrapper);
      if (!fetchedViewerWrapper) {
        console.warn('[Pack Gallery] No fetchedViewerWrapper in response HTML');
        return;
      }
      const allViewerSlides = Array.from(fetchedViewerWrapper.querySelectorAll('.swiper-slide'));
      const allThumbSlides = fetchedThumbWrapper ? Array.from(fetchedThumbWrapper.querySelectorAll('.swiper-slide')) : [];
      packGalleryLog('allViewerSlides count:', allViewerSlides.length, 'allThumbSlides:', allThumbSlides.length);
      const anyFetchedSlideHasGallery = allViewerSlides.some(s => {
        const a = (s.querySelector('img[alt]')?.getAttribute('alt') || '').toLowerCase();
        return a.includes('gallery');
      });
      if (!anyFetchedSlideHasGallery) {
        packGalleryLog('skip — no "gallery" in any fetched slide alt (leave Swiper untouched)');
        return;
      }
      allViewerSlides.forEach((s, i) => {
        const alt = s.querySelector('img[alt]')?.getAttribute('alt') || '(no alt)';
        packGalleryLog(`viewer slide ${i} alt:`, alt);
      });
      allThumbSlides.forEach((s, i) => {
        const alt = s.querySelector('img[alt]')?.getAttribute('alt') || '(no alt)';
        packGalleryLog(`thumb slide ${i} alt:`, alt);
      });
      const purchaseKey = getPurchaseTypeKey(root);
      const criteria = {
        packKey,
        purchaseKey
      };
      packGalleryLog('filtering criteria:', criteria);
      function filterSlides(slides) {
        const matched = slides.filter(slide => {
          const alt = slide.querySelector('img[alt]')?.getAttribute('alt') || '';
          return slideMatchesCriteria(alt, criteria);
        });
        if (matched.length > 0) return matched;
        const packOnly = slides.filter(slide => {
          const alt = slide.querySelector('img[alt]')?.getAttribute('alt') || '';
          return slideMatchesPackAlt(alt, packKey);
        });
        if (packOnly.length > 0) return packOnly;
        return slides;
      }
      const viewerSlides = filterSlides(allViewerSlides);
      const thumbSlides = filterSlides(allThumbSlides);
      packGalleryLog('viewerSlides after filter:', viewerSlides.length, 'thumbSlides:', thumbSlides.length);
      const viewerSlider = mediaGallery.querySelector('swiper-slider[data-gallery-viewer="true"]');
      const thumbSlider = mediaGallery.querySelector('swiper-slider[data-gallery-thumbnails="true"]');
      packGalleryLog('live viewerSlider:', viewerSlider, 'thumbSlider:', thumbSlider);
      const liveViewerWrapper = viewerSlider?.querySelector('.swiper .swiper-wrapper') || viewerSlider?.querySelector('.swiper-wrapper');
      const liveThumbWrapper = thumbSlider?.querySelector('.swiper .swiper-wrapper') || thumbSlider?.querySelector('.swiper-wrapper');
      packGalleryLog('liveViewerWrapper:', liveViewerWrapper, 'liveThumbWrapper:', liveThumbWrapper);
      if (!liveViewerWrapper) {
        console.warn('[Pack Gallery] No live viewer wrapper found');
        return;
      }
      destroySwiper(viewerSlider);
      destroySwiper(thumbSlider);
      liveViewerWrapper.innerHTML = viewerSlides.map(s => s.outerHTML).join('');
      if (liveThumbWrapper && thumbSlides.length) {
        liveThumbWrapper.innerHTML = thumbSlides.map(s => s.outerHTML).join('');
      }
      liveViewerWrapper.querySelectorAll('.thumbnail-list_item--variant').forEach(el => {
        el.classList.remove('thumbnail-list_item--variant');
      });
      liveThumbWrapper?.querySelectorAll('.thumbnail-list_item--variant').forEach(el => {
        el.classList.remove('thumbnail-list_item--variant');
      });
      packGalleryLog('DOM replaced. Viewer slides:', viewerSlides.length, 'Thumb slides:', thumbSlides.length);
      let attempts = 0;
      if (thumbSlider && liveThumbWrapper && thumbSlides.length) {
        thumbSlider.initialize(true);
        const waitForThumbs = () => {
          if (thumbSlider.swiperInstance) {
            packGalleryLog('thumbSlider initialized, now initializing viewer');
            viewerSlider.initialize(true);
            waitAndSlideToZero(thumbSlider);
            waitAndSlideToZero(viewerSlider);
            const linkSwipers = () => {
              const vi = viewerSlider?.swiperInstance;
              const ti = thumbSlider?.swiperInstance;
              packGalleryLog('linkSwipers — vi:', !!vi, 'ti:', !!ti);
              if (vi && ti) {
                vi.thumbs.swiper = ti;
                vi.thumbs.init();
                vi.thumbs.update(true);
                packGalleryLog('swipers linked successfully');
              } else if (attempts++ < 20) {
                setTimeout(linkSwipers, 50);
              }
            };
            setTimeout(linkSwipers, 200);
          } else if (attempts++ < 20) {
            setTimeout(waitForThumbs, 50);
          } else {
            console.warn('[Pack Gallery] thumbSlider never initialized after 20 attempts');
          }
        };
        setTimeout(waitForThumbs, 60);
      } else {
        packGalleryLog('No thumbSlider, initializing viewer only');
        viewerSlider.initialize(true);
        waitAndSlideToZero(viewerSlider);
      }
    }
    function handlePackChange(element, packIndex) {
      const root = element.closest('product-info') || document;
      updateSellingPlanForPack(root, packIndex);
      const packKey = getPackKeyFromElement(element);
      updateMediaForPack(root, packIndex, packKey);
      updateMultiPackPrice(root);
    }
    function computeMultiPackTotalCents(packSelectorRoot) {
      const productInfo = packSelectorRoot.closest('product-info') || document;
      const checkedPack = packSelectorRoot.querySelector('input[type="radio"][name="pack"]:checked');
      const packKey = checkedPack ? getPackKeyFromElement(checkedPack) : '';
      const packQty = parseInt(checkedPack?.dataset?.packQuantity || '1', 10) || 1;
      if (!packKey) return {
        total: 0,
        compareTotal: 0
      };
      const packForm = productInfo.querySelector && productInfo.querySelector('pack-product-form') || document.querySelector('pack-product-form');
      const variants = packForm?.currentProduct?.variants;
      const selectors = productInfo.querySelectorAll(`.flavor-selector-${CSS && CSS.escape ? CSS.escape(packKey) : packKey}`);
      let total = 0;
      let compareTotal = 0;
      let counted = 0;
      selectors.forEach(selector => {
        if (selector.style.display === 'none') return;
        const slotSelects = selector.querySelectorAll('select[data-pack-key][data-flavor-index]');
        if (slotSelects.length && variants && variants.length) {
          const values = Array.from(slotSelects).map(s => s.value);
          const variant = variants.find(v => Array.isArray(v.options) && v.options.every((opt, idx) => opt === values[idx]));
          if (variant) {
            total += variant.price;
            const cmp = variant.compare_at_price;
            compareTotal += cmp != null && cmp > variant.price ? cmp : variant.price;
            counted += 1;
            return;
          }
        }
        const select = selector.querySelector('select');
        if (!select) return;
        const opt = select.options[select.selectedIndex];
        if (!opt) return;
        const price = parseInt(opt.dataset.variantPrice || '', 10);
        if (Number.isFinite(price)) {
          total += price;
          const cmp = parseInt(opt.dataset.variantCompareAtPrice || '', 10);
          compareTotal += Number.isFinite(cmp) && cmp > price ? cmp : price;
          counted += 1;
        }
      });
      if (counted > 0) return {
        total,
        compareTotal
      };
      if (packSelectorRoot.dataset.packUseQuantityPricing === 'true') {
        if (variants && variants.length) {
          const vid = packSelectorRoot.dataset.packPricingVariantId;
          const v = variants.find(x => String(x.id) === String(vid));
          if (v) {
            const t = v.price * packQty;
            const c = v.compare_at_price != null && v.compare_at_price > v.price ? v.compare_at_price * packQty : t;
            return {
              total: t,
              compareTotal: c
            };
          }
        }
        const unitPrice = parseInt(packSelectorRoot.dataset.packPricingVariantPrice || '', 10);
        if (Number.isFinite(unitPrice)) {
          const t = unitPrice * packQty;
          return {
            total: t,
            compareTotal: t
          };
        }
      }
      try {
        const script = productInfo.querySelector && productInfo.querySelector('script[type="application/json"][data-selected-variant]') || document.querySelector('script[type="application/json"][data-selected-variant]');
        if (script) {
          const parsed = JSON.parse(script.textContent || 'null');
          if (parsed && typeof parsed.price === 'number') {
            const t = parsed.price * packQty;
            const c = parsed.compare_at_price != null && parsed.compare_at_price > parsed.price ? parsed.compare_at_price * packQty : t;
            return {
              total: t,
              compareTotal: c
            };
          }
        }
      } catch (_) {}
      return {
        total: 0,
        compareTotal: 0
      };
    }
    function formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents);
      }
      return `$${(cents / 100).toFixed(2)}`;
    }
    function updateMultiPackPrice(root) {
      const productInfo = root?.closest?.('product-info') || (root?.tagName === 'PRODUCT-INFO' ? root : null);
      const scope = productInfo || document;
      if (productInfo && productInfo.dataset.mainSellingPlans === 'true') return;
      const packSelectorRoot = scope.querySelector('.pack-selector[data-multi-pack="true"]');
      if (!packSelectorRoot) return;
      const {
        total,
        compareTotal
      } = computeMultiPackTotalCents(packSelectorRoot);
      if (!Number.isFinite(total) || total <= 0) return;
      const sectionId = productInfo?.dataset?.section;
      const priceNodes = sectionId ? scope.querySelectorAll(`[id="price-${CSS && CSS.escape ? CSS.escape(sectionId) : sectionId}"]`) : scope.querySelectorAll('[id^="price-"]');
      const formatted = formatMoney(total);
      const formattedCompare = compareTotal > total ? formatMoney(compareTotal) : '';
      priceNodes.forEach(holder => {
        const saleEl = holder.querySelector('.price-item--sale.price-item--last');
        const regularEl = holder.querySelector('.price__regular .price-item--regular');
        const target = saleEl || regularEl;
        if (target) target.textContent = formatted;
        if (regularEl && regularEl !== target) regularEl.textContent = formatted;
        const compareEls = holder.querySelectorAll('.price-item--regular s, s.price-item--regular, .price__sale s');
        compareEls.forEach(el => {
          if (formattedCompare) {
            el.textContent = formattedCompare;
            el.style.display = '';
          } else {
            el.textContent = '';
          }
        });
        holder.classList.toggle('price--on-sale', Boolean(formattedCompare));
      });
    }
    function bindMultiPackFlavorSelects(packSelectorRoot) {
      const productInfo = packSelectorRoot.closest('product-info') || document;
      const selects = productInfo.querySelectorAll('[class*="flavor-selector-"] select[data-pack-key][data-flavor-index]');
      selects.forEach(select => {
        if (select.dataset.multiPackPriceBound === 'true') return;
        select.dataset.multiPackPriceBound = 'true';
        select.addEventListener('change', () => updateMultiPackPrice(productInfo));
      });
    }
    function initPackSelector(packSelectorRoot) {
      if (!packSelectorRoot || packSelectorRoot.dataset.multiPackBound === 'true') return;
      packSelectorRoot.dataset.multiPackBound = 'true';
      const radioInputs = packSelectorRoot.querySelectorAll('.pack-options-container input[type="radio"][name="pack"]');
      radioInputs.forEach((input, index) => {
        input.addEventListener('change', event => {
          if (!event.target.checked) return;
          handlePackChange(event.target, index);
        });
      });
      const dropdownOptions = packSelectorRoot.querySelectorAll('.pack-select-dropdown__option');
      dropdownOptions.forEach((button, index) => {
        button.addEventListener('click', event => {
          handlePackChange(event.currentTarget, index);
        });
      });
      const root = packSelectorRoot.closest('product-info') || document;
      root.querySelectorAll('[name="purchase_option"]').forEach(radio => {
        radio.addEventListener('change', () => {
          const currentPack = packSelectorRoot.querySelector('.pack-options-container input[type="radio"][name="pack"]:checked');
          if (!currentPack) return;
          const allInputs = Array.from(packSelectorRoot.querySelectorAll('.pack-options-container input[type="radio"][name="pack"]'));
          const idx = Math.max(0, allInputs.indexOf(currentPack));
          const packKey = getPackKeyFromElement(currentPack);
          updateMediaForPack(root, idx, packKey);
          updateMultiPackPrice(root);
        });
      });
      bindMultiPackFlavorSelects(packSelectorRoot);
      updateMultiPackPrice(root);
    }
    function initAll() {
      document.querySelectorAll('.pack-selector[data-multi-pack="true"]').forEach(initPackSelector);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    return {
      init: initAll,
      initPackSelector
    };
  }();
}
/******/ })()
;